import { render, staticRenderFns } from "./MalzemeTanimla.vue?vue&type=template&id=4e9c3aa4&scoped=true&"
import script from "./MalzemeTanimla.vue?vue&type=script&lang=js&"
export * from "./MalzemeTanimla.vue?vue&type=script&lang=js&"
import style0 from "./MalzemeTanimla.vue?vue&type=style&index=0&id=4e9c3aa4&scoped=true&lang=css&"
import style1 from "./MalzemeTanimla.vue?vue&type=style&index=1&id=4e9c3aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9c3aa4",
  null
  
)

export default component.exports